module.exports = __webpack_public_path__ + "static/media/char_person.d400e7a3.png";